// Keep this module free of imports. Anything reachable from here is also reachable from the
// Cypress specs, whose bundler resolves neither `baseUrl: src` absolute imports nor `.tsx`.

export enum JobFormFieldName {
  ImmediateDispatch = 'immediateDispatch',
  ImmediateDispatchDay = 'immediateDispatchDay'
}

export enum DispatchDay {
  Today = 'TODAY',
  Tomorrow = 'TOMORROW'
}
